﻿import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {UIText} from "../Tools/Base/UIText";
import {Core} from "../../Base/Core";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";

export class UIReset extends UICommonPopup {
    Awake() {
        super.Awake({
            closeButton: false,
        });

        this.description = this.content.addChild(new UIText(Core.Localizator.Get("reset_confirm"), {wordWrap: true}));
        this.yesBtn = this.content.addChild(new UINineSliceButton("btn-green", { label: Core.Localizator.Get("yes") }));
        this.noBtn = this.content.addChild(new UINineSliceButton("btn-orange", { label: Core.Localizator.Get("no") }));

        this.noBtn.on("pointertap", () => this.Hide());
        this.yesBtn.on("pointertap", () => Core.Reset());
    }

    fitLayout(viewport = Core.app.viewport) {
        let sideRatio = 0.9;
        let w = Math.min(viewport.width * 0.8, (viewport.height * 0.8) / sideRatio);
        let h = w * sideRatio;

        this.setPopupRect(new PIXI.Rectangle((viewport.width - w) * 0.5, (viewport.height - h) * 0.5, w, h));

        super.fitLayout(viewport);

        let popupRect = this.getContentSize();

        let rect = popupRect.clone();
        rect.height = popupRect.height * 0.7;
        rect.width = popupRect.width * 0.85;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.1;
        this.description.fitLayout(rect);

        rect = popupRect.clone();
        rect.width = popupRect.width * 0.4;
        rect.height = popupRect.height * 0.2;
        rect.x = (popupRect.width - rect.width) * 0.1;
        rect.y = (popupRect.height - rect.height) * 0.94;
        this.yesBtn.fitLayout(rect);

        rect.x = (popupRect.width - rect.width) * 0.9;
        this.noBtn.fitLayout(rect);
    }
}
